import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { FaCheckCircle } from "react-icons/fa";

function Orderpop({ onClose }) {
  return (
    <>
      <main className="container-fluid">
        <Header />
        <div className="row justify-content-center text-center py-5">
          <div className="col-6">
           
            <div className="popup-icon">
              <FaCheckCircle size={60} color="green" />
            </div>

            <h2>Order Successful!</h2>
            <p>Your order has been placed successfully.</p>
  
          </div>
        </div>
        <Footer />
      </main>
    </>
  );
}

export default Orderpop;
